import { AfterViewInit, Component, HostListener } from '@angular/core';
import { BreadcrumbProvider } from '../../providers/breadcrumb-provider';
import { NgForOf, NgIf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'breadcrumb',
  providers: [],
  styleUrls: ['./breadcrumb.scss'],
  standalone: true,
  imports: [
    NgForOf,
    TranslateModule,
    MatButton,
    NgIf
  ],
  templateUrl: './breadcrumb.html'
})
export class BreadcrumbBreadcrumbComponent implements AfterViewInit {
    constructor(
        public breadcrumbProvider: BreadcrumbProvider
    ) {
    }

    public ngAfterViewInit() {
    }

    @HostListener('window:popstate', ['$event'])
    public onPopState(event: Event) {
        this.breadcrumbProvider.onBackClicked();
    }
}
